import React, { Component } from "react";
import './App.css';
import "bootstrap/dist/css/bootstrap.css";
import { isLogin } from "./authentication/authorizer";
import { baseUrl } from "./app-setting";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updateIsLogin } from "./redux/actions";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import Routes from "./routes";
import Toolbar from "./toolbar/toolbar"
import ToolbarPlaceHolder from "./toolbar/toolbar-placeholder"


class App extends Component {
  state = {
    navOpened: false,
  };

  componentDidMount() {
    axios.defaults.baseURL = baseUrl;
    var il = isLogin()
    this.props.updateIsLogin(il)
  }

  render() {
    return (
      <React.Fragment >
        <div className="app" >
          <div >
            {this.props.login.isLogin !== undefined && this.props.login.isLogin === "true" &&
             <Toolbar
             history={this.props.history}
             navOpened={this.state.navOpened}
              toggleNav={this.toggleNav}
            />}
            
            {(this.props.login.isLogin === undefined || this.props.login.isLogin === null || this.props.login.isLogin === "false") &&
             <ToolbarPlaceHolder
              navOpened={this.state.navOpened}
              toggleNav={this.toggleNav}
            />}
            
           
              <Container className="main-container"  >

                <Routes 
                  isLogin={this.props.login.isLogin}
                />

              </Container>

           
          </div>
          
          <ToastContainer
         className="text-right"
          position="bottom-right"
          autoClose={2500}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          style={{marginBottom: 0, marginRight: 0, marginLeft: 0,  direction: "rtl"}}
        />
        </div>
      
      </React.Fragment>
    );
  }

  toggleNav = () => {
    if (this.state.navOpened === false) {
      this.setState({ navOpened: true });
    } else {
      this.setState({ navOpened: false });
    }
  };
}


//// REDUX STUFF
function mapStateToProps(state) {
  return {
    login: state.login,
    sideMenu: state.sideMenu,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateIsLogin: updateIsLogin,
    },
    dispatch
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(App);
